/**
 * KDS Progress Bar — Kintsugi Design System node 1062:11557.
 *
 * Single track height (12px), pill shape, title row with percentage.
 */
export const progressTrackHeight = '12px';

/** Gap between title row and track — Figma `md` (12px). */
export const progressLabelGap = '3';

/** Minimum fill width at 0% — renders as a circle matching track height. */
export const progressRangeMinWidth = progressTrackHeight;
